import { Button } from "components/Button";
import { Hero } from "components/Hero";
import { LARGE, GREY } from "shared/variables";
import { MaxWidth } from "components/MaxWidth";
import { Page } from "components/Page";
import { PeopleListWrapper } from "components/PeopleList";
import { RichText } from "components/slices/RichText";
import { SpacingSection } from "components/SpacingSection";
import { useState } from "react";

export const PeopleOverviewPage = ({ doc, people, preview, filters }) => {
  const [page, setPage] = useState(1);

  const {
    seo_title,
    seo_description,
    seo_image,
    hero_image,
    hero_text,
    hero_title,
    intro_rich_text,
  } = doc.data;

  const renderHero =
    hero_image?.alt || hero_image?.src || hero_title || hero_text;

  return (
    <Page
      title={seo_title}
      description={seo_description}
      image={seo_image}
      preview={preview}
    >
      {renderHero && (
        <Hero
          image={{ alt: hero_image.alt, src: hero_image.url }}
          title={hero_title}
          text={hero_text}
        />
      )}
      <SpacingSection size={LARGE}>
        <MaxWidth>
          {intro_rich_text && <RichText content={intro_rich_text} />}
          <SpacingSection>
            <PeopleListWrapper
              people={people}
              filters={filters}
              type={doc.type}
            />
          </SpacingSection>
          {/* {renderButton && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button color={GREY} onClick={() => setPage(page + 1)}>
                Toon meer
              </Button>
            </div>
          )} */}
        </MaxWidth>
      </SpacingSection>
    </Page>
  );
};
